export default __webpack_public_path__ + "1fcce5a5d0e2c814bd609c574bf1d846.png";